module.exports = __webpack_public_path__ + "static/amazon-ade98be66396f75048d93f2c57d7af5a.png";